// home-editor-03 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "Layout da Home": "Diseño del Inicio",
};

export default catalogo;
